import { Component, OnInit, inject } from '@angular/core';
import { ClosetDoorsStandardService } from 'src/app/services/configurators-2d/applications/closet-doors-standard.service';
import { CurrentService } from 'src/app/services/current.service';
import { ModalService, MODAL } from 'src/app/services/modal.service';
import { Accessory } from 'src/app/models/configurators-2d/applications/closet-doors-standard/accessory';

/**
 * Gestion de la plinthe : présence, besoin d'un compensateur de plinthe
 * et quantité associée.
 */
@Component({
  selector: 'ng-closet-doors-standard-door-plinth',
  templateUrl: './plinth.component.html',
  styleUrls: ['./plinth.component.scss'],
})
export class ClosetDoorsStandardDoorPlinthComponent implements OnInit {
  private readonly modalService = inject(ModalService);
  private readonly closetDoorsService = inject(ClosetDoorsStandardService);
  readonly current = inject(CurrentService);

  /** Accessoire « compensateur de plinthe » (catégorie 1), pour son info-bulle. */
  baseboardAccessory: Accessory | undefined;

  ngOnInit(): void {
    this.closetDoorsService.getAccessories().then((res: Accessory[]) => {
      this.baseboardAccessory = res.find(a => a.category === 1);
    });
  }

  /**
   * Fonction de sélection des plinthes
   */
  selectHasPlinth(): void {
    if (this.current.closetDoors.hasPlinth) {
      this.modalService.display(MODAL.CLOSET_DOORS_PLINTH_INFO, {});
      return;
    }
    this.current.closetDoors.needBaseboardCompensator = false;
    this.current.closetDoors.baseboardCompensatorQty = 0;
  }

  /**
   * Fonction de sélection des compensateurs de plinthe
   */
  selectNeedBaseboardCompensator(): void {
    if (!this.current.closetDoors.needBaseboardCompensator) {
      this.current.closetDoors.baseboardCompensatorQty = 0;
    }
  }
}
